import React, { useState } from 'react';
import { connect } from 'react-redux';
import CalendarPaginator from '../../components/calender-paginator';
import Header from '../../components/common/global-top-bar';
import Spinner from '../../components/common/spinner';
import { useReportingSnapshot } from '../../hooks/useReporting';

const SnapShot: React.FunctionComponent = (): JSX.Element => {
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const { data: snapShotData, isLoading: snapShotLoading } = useReportingSnapshot(startDate, endDate);

  const changedDate = (startdate: string, enddate: string) => {
    setStartDate(startdate);
    setEndDate(enddate);
  };

  const handleDownload = (date: any) => {
    const data =
      snapShotData &&
      snapShotData?.package_metrics.length > 0 &&
      snapShotData.package_metrics.map((item: any) => {
        return [
          item.code,
          `${item.eligible} (${((item.eligible / (snapShotData?.total_eligible_members || 100)) * 100).toFixed(2)}) %`,
          `${item.activated} (${item.activated_percentage} %)`,
          `${item.engaged} (${item.engaged_percentage} %)`,
          `${item.connected} (${item.connected_percentage} %)`,
        ];
      });
    const headings = [
      ' Group ID ',
      '  Eligible Members ',
      ' Activated Members ',
      ' Engaged Members ',
      '  Connected Members ',
    ];

    const csvData = [headings, ...(data || [])];

    let lineArray = csvData.map((infoArray) => {
      const line = infoArray.join(',');
      return line;
    });

    const csvContent = lineArray.join('\n');

    const downloadLink = document.createElement('a');
    const blob = new Blob(['\ufeff', csvContent]);
    const url = URL.createObjectURL(blob);
    downloadLink.href = url;
    downloadLink.download = `Snapshot-${date.startdate.format('YYYY-MM-DD')}-${date.enddate.format('YYYY-MM-DD')}.csv`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  return (
    <div>
      {snapShotLoading && <Spinner />}
      <Header heading="Snapshot" />
      <CalendarPaginator changedDate={changedDate} handleDownload={handleDownload} />
      <div className="max-window-height-group overflow-y-auto px-7">
        <div className="w-1/4 py-7">
          <div className="text-gray-dark text-bold border-bottom pr-2 font-bold">Total Eligible Members</div>
          <div className="blue-primary py-7 text-2xl font-bold">{snapShotData?.total_eligible_members || 0}</div>
        </div>
        <table className="table-row-format relative w-full table-fixed border-collapse">
          <thead className="h-full bg-white">
            <tr className="w-full px-7 text-left">
              <th className="sticky top-0 mb-4 h-full w-2/12 bg-white px-2 py-1 font-normal">Group ID</th>
              <th className="sticky top-0 mb-4 h-full w-2/12 bg-white px-2 py-1 font-normal">Group Name</th>
              <th className="text-gray-dark sticky top-0 mb-4 h-full w-2/12 bg-white px-2 py-2 text-base font-normal">
                Eligible Members
              </th>
              <th className="text-gray-dark sticky top-0 mb-4 h-full w-2/12 bg-white px-2 py-2 text-base font-normal">
                Activated Members
              </th>
              <th className="text-gray-dark sticky top-0 mb-4 h-full w-2/12 bg-white px-2 py-1 text-base font-normal">
                Engaged Members
              </th>
              <th className="text-gray-dark sticky top-0 mb-4 h-full w-2/12 bg-white px-2 py-2 text-base font-normal">
                Connected Members
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="h-2"></tr>
            {snapShotData?.package_metrics &&
              snapShotData?.package_metrics.length > 0 &&
              snapShotData.package_metrics.map((item: any) => {
                return (
                  <tr
                    role="button"
                    className="text-gray-dark h-12 space-y-6 rounded border-4 border-y border-white text-left"
                  >
                    <td className="text-gray-dark text-bold border-bottom w-2/12 py-1 font-bold">
                      <div className="truncate">{item.code}</div>
                    </td>
                    <td className="text-gray-dark text-bold border-bottom w-2/12 py-1 font-bold">
                      <div className="truncate">{item.client_name}</div>
                    </td>
                    <td className="blue-primary border-bottom w-2/12 py-1">
                      <div className="flex">
                        {/* <p className="text-gray-dark text-base">(20%)</p> */}
                        <p className="text-gray-dark text-bold pr-2 font-bold">{item.eligible}</p>
                        <p className="text-gray-dark text-base">
                          ({((item.eligible / (snapShotData?.total_eligible_members || 100)) * 100).toFixed(2)} %)
                        </p>
                      </div>
                    </td>
                    <td className="border-bottom w-2/12 py-1">
                      <div className="flex">
                        {' '}
                        <p className="text-gray-dark text-bold pr-2 font-bold">{item.activated}</p>
                        <p className="text-gray-dark text-base">({item.activated_percentage} %)</p>
                      </div>
                    </td>
                    <td className="border-bottom w-2/12 py-1">
                      <div className="flex">
                        <p className="text-gray-dark text-bold pr-2 font-bold">{item.engaged}</p>
                        <p className="text-gray-dark text-base">({item.engaged_percentage} %)</p>
                      </div>
                    </td>
                    <td className="border-bottom w-2/12 py-1">
                      <div className="flex">
                        <p className="text-gray-dark text-bold pr-2 font-bold">{item.connected}</p>
                        <p className="text-gray-dark text-base">({item.connected_percentage} %)</p>
                      </div>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SnapShot;
